<template>
  <v-data-table
    :headers="headPart"
    :items="statPart"
    v-model:expanded="expanded"
    item-key="name"
    show-expand
    class="elevation-1 mx-1"
  >
    <template v-slot:expanded-item="{ item }">
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3 ml-5">
          {{ source.name }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per1Group1 }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per1Group2 }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per1Total }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per2Group1 }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per2Group2 }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per2Total }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per3Group1 }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per3Group2 }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per3Total }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per4Group1 }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per4Group2 }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per4Total }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per5Group1 }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per5Group2 }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per5Group3 }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per5Total }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per6Group1 }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per6Group2 }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.per6Total }}
        </p>
      </td>
      <td>
        <p v-for="(source, index) in item.sources" :key="index" class="my-3">
          {{ source.perTotal }}
        </p>
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'VTableExtenStatisticsB',
  props: ['headPart', 'statPart'],
  data() {
    return {
      expanded: [],
      singleExpand: false,
    };
  },
};
</script>
